import { render } from "./BasketItem_confirmation.vue?vue&type=template&id=7f4add65"
import script from "./BasketItem_confirmation.vue?vue&type=script&lang=js"
export * from "./BasketItem_confirmation.vue?vue&type=script&lang=js"

import "./BasketItem_confirmation.vue?vue&type=style&index=0&id=7f4add65&lang=scss"

import exportComponent from "/codebuild/output/src3487515193/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__